const MoienTafsil = ({ stroke, fill }: { fill?: string, stroke?: string }) => {
    return (<>
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.25 22C9.11748 22 10.6861 20.7202 11.1266 18.9899C11.2628 18.4547 11.6977 18 12.25 18H19.25M7.25 22C5.04086 22 3.25 20.2091 3.25 18V5C3.25 3.34315 4.59315 2 6.25 2H16.25C17.9069 2 19.25 3.34315 19.25 5V18M7.25 22H19.25C21.1175 22 22.6861 20.7202 23.1266 18.9899C23.2628 18.4547 22.8023 18 22.25 18H19.25M15.25 7H7.25M11.25 12H7.25" stroke={stroke ? stroke : "#323232"} stroke-width="1.5" stroke-linecap="round" />
        </svg>

    </>);
}

export default MoienTafsil;